import { useCallback } from 'react'
import { signOut } from './operations'
import { useDispatch } from 'react-redux'
import { clearAuthorizationToken, clearRefreshToken } from '~/service/api'

export const useSignOut = () => {
  const dispatch = useDispatch()
  const connectedSignOut = useCallback(() => {
    dispatch(signOut())
    clearAuthorizationToken()
    clearRefreshToken()
  }, [dispatch])

  return connectedSignOut
}
